import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import "@/i18n";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Suspense fallback={<div className="flex items-center justify-center min-h-screen bg-slate-950 text-white">Cargando...</div>}>
        <App />
      </Suspense>
    </HelmetProvider>
  </React.StrictMode>,
);
